var _circle, _circle2, _circle3, _path, _path2, _circle4, _circle5, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBall40 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_25156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "url(#paint0_radial_51_25156)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_25156)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "#EB5757"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 -6L48.3956 18.5625L75.8954 23.7123L56.6746 44.0425L60.2748 71.7877L35 59.79L9.72523 71.7877L13.3254 44.0425L-5.89543 23.7123L21.6044 18.5625L35 -6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9136 14.3676L51.1411 14.7845L51.6069 14.8715L84.2749 20.9886L61.4419 45.141L61.1157 45.4857L61.1772 45.9564L65.4536 78.9154L35.4292 64.6635L35.0005 64.4603L34.5708 64.6635L4.54541 78.9154L8.82275 45.9564L8.88428 45.4857L8.55811 45.141L-14.2759 20.9886L18.3931 14.8715L18.8599 14.7845L19.0864 14.3676L34.9995 -14.8121L50.9136 14.3676Z",
    stroke: "white",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "url(#paint1_radial_51_25156)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1868 46.4474V40.7362H14.5205V37.3234L23.4705 23.8114H31.2363V36.9751H35.4153V40.7362H31.2363V46.4474H26.1868ZM19.7442 36.9751H26.2912V27.9555H25.3858L19.7442 36.3831V36.9751ZM45.9832 46.9349C40.1675 46.9349 36.3368 42.1988 36.3368 35.1294C36.3368 28.06 40.1675 23.3239 45.9832 23.3239C51.7641 23.3239 55.5948 28.06 55.5948 35.1294C55.5948 42.1988 51.7641 46.9349 45.9832 46.9349ZM41.456 35.1294C41.456 40.2138 43.232 43.1042 45.9832 43.1042C48.7343 43.1042 50.5104 40.2138 50.5104 35.1294C50.5104 30.045 48.7343 27.1546 45.9832 27.1546C43.232 27.1546 41.456 30.045 41.456 35.1294Z",
    fill: "#082037"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_51_25156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2067 29.3832) rotate(49.2364) scale(41.668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_51_25156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2067 29.3832) rotate(49.2364) scale(41.668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBall40);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ball-40.83f91b749502634a95f3d12b21ae1412.svg";